import styled from '@emotion/styled';
import { color, font } from 'src/shared/styles/variables';

interface AnswerElementProps {
    isHighlighted?: boolean;
}

export const Answer = styled.li<AnswerElementProps>(({ isHighlighted }) => {
    const currentFont = isHighlighted ? font.heavy(font.size.medium) : font.roman(font.size.medium);

    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: color.white,
        color: isHighlighted ? color.ebonyClay : color.blueBayoux,
        padding: '19px 1rem',
        border: `2px solid ${isHighlighted ? color.royalBlue : color.linkWaterLight}`,
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        userSelect: 'none',
        borderRadius: 6,
        marginBottom: 10,
        minHeight: 64,
        width: 500,
        ...currentFont,
    };
});
